import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import IconComponent from "../../../components/common/IconComponent";
import ShadowCard from "../../../components/common/ShadowCard";

const WhatsappIcon = FaWhatsapp as any;

interface BulkWhatsappHeaderProps {
  selectedCount?: number;
  isSendAccess?: boolean;
}

export const BulkWhatsappHeader: React.FC<BulkWhatsappHeaderProps> = () => {
  return (
    <ShadowCard
      style={{
        background: "linear-gradient(135deg, #174583 0%, #174583 100%)",
        borderRadius: "16px",
        padding: "16px 24px",
        marginBottom: "20px",
        color: "#ffffff",
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "16px",
      }}
    >
      {/* Left side: Back Button & Title */}
      <div style={{ display: "flex", alignItems: "start", gap: "14px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              padding: "10px 10px 10px 5px",
              borderRadius: "12px",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconComponent icon={WhatsappIcon} style={{ fontSize: "22px" }} />
          </div>

          <div>
            <h2
              style={{
                margin: 0,
                fontSize: "19px",
                fontWeight: 700,
                color: "#ffffff",
                letterSpacing: "-0.02em",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              Bulk WhatsApp
            </h2>
            <p
              style={{
                margin: "2px 0 0 0",
                fontSize: "12px",
                color: "#ffffff",
                fontWeight: 400,
              }}
            >
              Send personalized WhatsApp messages with real-time variable
              mapping
            </p>
          </div>
        </div>
      </div>
    </ShadowCard>
  );
};
